import styles from '../../my-profile-page/MyProfilePage.module.scss';
import locationImg from 'assets/images/location-black.svg';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import countryFlag from 'assets/images/kuwait-flag-round.jpg';
import { useDispatch, useSelector, connect } from 'react-redux';
import { commonActions } from '../../../stores/_actions';
import axios from 'axios';
import environment from 'environment';

function Profile(props) {
  const location = useLocation();
  const style = location.pathname == '/more' ? styles.width35 : styles.width65;
  const pic = location.pathname == '/more' ? styles.contactPic : '';

  const [fimage, setFrontImage] = useState('');
  const [bimage, setBackImage] = useState('');
  const [filesize, setFileSize] = useState('');

  function imageValidation(file, face) {
    if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/svg+xml') {
      face == 'custimg' ? setFrontImage('') : setBackImage('');
    } else {
      //face == 'IDFront' ? customer.imgErr1 = 1 : customer.imgErr2 = 1

      const message = 'Invalid image format, Please upload only jpg, png, jpeg files';
      face == 'Profile' ? setFrontImage((fimage) => (fimage = message)) : setBackImage((bimage) => (bimage = message));
      // setFileSize((filesize)  => (filesize = 'invalid image format, Please upload only jpg, png, jpeg files'));
      return;
    }
  }

  function imageSizeValidation(file) {
    if (file.size > 2000000) {
      setFileSize((filesize) => (filesize = 'file size is greater then 2MB'));
      return;
    }
  }

  const cameraUpload = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    imageValidation(file, 'Profile');
    imageSizeValidation(file);
    formData(file, 'Profile');
    setTimeout(() => {
      // setCustomer((customer) => ({ ...customer, IdImageFront: file.name }));
    }, 100);
  };

  function formData(file, doctype) {
    const endpoint = environment.api.uploadMedia;
    let form_data = new FormData();
    form_data.append('Image', file, file.name);
    form_data.append('DocType', doctype);
    // form_data.append('CustomerCode', customer.custId);
    // form_data.append('IDNO', customer.IDNo);
    // let url = 'http://103.121.26.154:91/eastern/mobremitclient/api/admin/UploadMedia';
    axios
      .post(endpoint, form_data, {
        headers: {
          'content-type': 'multipart/form-data',
          'Content-Type': 'image/jpeg',
        },
      })
      .then((res) => {})
      .catch((err) => console.log(err));
  }

  const image = location.pathname === '/more' ? props.userProfile?.ProfImage : countryFlag;

  return (
    <div className={styles.pageLeft__left + ' ' + style}>
      {/* {location.pathname == '/more' ? <div className={styles.profileH}>
          <p>{props.userProfile && props.userProfile.FirstName}</p>
         <p>{props.userProfile && props.userProfile.Addr1}</p>
      </div> : ''} */}
      {location.pathname == '/more' ? (
        <div className={styles.pageRight__profile + ' ' + styles.contactProfile}>
          <h3>
            {props.userProfile && props.userProfile.FirstName}{' '}
            <span>
              <img src={locationImg} alt="" />
              {props.userProfile && props.userProfile.Addr1}
            </span>
          </h3>
          {/* <img className={styles.pageRight__profilePic} src={props.userProfile && props.userProfile.ProfileImage} alt="" /> */}
        </div>
      ) : (
        ''
      )}
      <div className={styles.pageLeft__profile + ` ` + pic}>
        <img className={styles.pageLeft__profilePic} src={image} alt="" />
        {/* <span className={styles.pageLeft__iconButton}>
          <input type="file" name="IdImageFront" value="" className={styles.pageLeft__iconButton} onChange={cameraUpload} />
        </span> */}
      </div>
      <div className={styles.pageLeft__profileDetail}>
        <p>
          id<span>{props.userProfile && props.userProfile.IDNo}</span>
        </p>
        <p>
          First Name<span>{props.userProfile && props.userProfile.FirstName}</span>
        </p>
        <p>
          Last Name<span>{props.userProfile && props.userProfile.LastName}</span>
        </p>
        <p>
          Address<span>{props.userProfile && props.userProfile.Addr1}</span>
        </p>
        <p>
          Mobile number<span>{props.userProfile && props.userProfile.MobileNo}</span>
        </p>
        <p>
          Date of Birth<span>{props.userProfile && props.userProfile.DOB}</span>
        </p>
        <p>
          ID Expiry Date<span>{props.userProfile && props.userProfile.IDExpiryDate}</span>
        </p>
      </div>
    </div>
  );
}

export { Profile };
